import MelodyGrid from 'components/landing/MelodyGrid';
import MelodyCurated from 'components/landing/MelodyCurated';
import MelodyCarousel from 'components/common/MelodyCarousel';
import MelodyCardProduct from 'components/common/melodyCard/MelodyCardProduct';
import ProductList from 'components/landing/ProductList';
import ProductGrid from 'components/common/ProductGrid';
import ProductCarousel from 'components/common/ProductCarousel';

import css from 'styles/components/landing/productSearch.scss';

const ProductSearch = props => {
  const { slotName, slotDetails, onLandingComponentClick, shouldLazyLoad, slotHeartsData } = props;
  if (slotDetails.products && slotDetails.products.length > 0) {
    const { style, title, products, monetateId } = slotDetails;
    switch (style) {
      case 'melody-grid':
        return <MelodyGrid {...props} shouldLazyLoad={shouldLazyLoad}/>;
      case 'melody-grid-half':
        return <MelodyGrid {...props} isHalf={true} shouldLazyLoad={shouldLazyLoad}/>;
      case 'melody-curated':
        return <MelodyCurated {...props}/>;
      case 'product-list':
        return <ProductList {...props}/>;
      case 'product-grid':
        return <ProductGrid {...props}/>;
      case 'carousel':
        return <ProductCarousel {...props}/>;
      default: // style === 'melody' or no style property provided
        const heartsData = style === 'melody' ? slotHeartsData : undefined;
        return (
          <div className={css.wrap} data-slot-id={slotName} data-monetate-id={monetateId}>
            <h2 className={css.title}>{title}</h2>
            <MelodyCarousel>
              {products.map((product, index) => <MelodyCardProduct
                cardData={product}
                componentStyle="productSearchNoStyle"
                eventLabel="productSearch"
                onComponentClick={onLandingComponentClick}
                key={index}
                heartsData={heartsData} />)}
            </MelodyCarousel>
          </div>
        );
    }
  } else {
    return null;
  }
};

export default ProductSearch;
